import { createContext, useContext, useState, ReactNode, useCallback, useMemo } from 'react'

interface MenuContextType {
    isMenuOpen: boolean
    toggleMenu: () => void
    closeMenu: () => void
}

const MenuContext = createContext<MenuContextType | undefined>(undefined)

export const MenuProvider = ({ children }: { children: ReactNode }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    const toggleMenu = useCallback(() => {
        setIsMenuOpen(prev => !prev)
    }, [])

    const closeMenu = useCallback(() => {
        setIsMenuOpen(false)
    }, [])

    const contextValue = useMemo(() => ({
        isMenuOpen,
        toggleMenu,
        closeMenu
    }), [isMenuOpen, toggleMenu, closeMenu])

    return (
        <MenuContext.Provider value={contextValue}>
            {children}
        </MenuContext.Provider>
    )
}

export const useMenu = () => {
    const context = useContext(MenuContext)
    if (context === undefined) {
        throw new Error('useMenu must be used within a MenuProvider')
    }
    return context
}
